export default {
  txt_welcome: 'Welcome to Tyrehub',
  txt_dataover: 'Overview',
  txt_chance: 'Sales Leads',
  txt_device: 'Device',
  txt_Device: 'Device',
  txt_chinese: '中文-Chinese',
  txt_english: '英文-English',
  txt_malay: '马来语-Malay',
  txt_reports: 'Record',
  txt_setting: 'Setting',
  txt_dymanager: 'Employees',
  txt_account: 'User ID',
  txt_userstatus: 'User',
  txt_name: 'Name',
  txt_contactway: 'Contact',
  txt_accountsafe: 'Account Security',
  txt_basicinfo: 'Information',
  txt_updatepassword: 'Modify Passwordv',
  txt_storeinfomation: 'Store Information',
  txt_storename: 'Store Name',
  txt_storephone: 'Mobile Phone',
  txt_storeaddress: 'Address',
  txt_AppInfomation: 'App',
  txt_currentversion: 'Version',
  txt_software: 'Software Update',
  txt_loginout: 'Exit Login',
  txt_updatelanguage: 'Language',
  txt_updateto: 'Update to',
  txt_zwgx: 'No update for the time being',
  txt_dz: 'Manager',
  txt_sh: 'Business',
  txt_dy: 'Sales Assistant',
  txt_bdsj: 'Bind mobile phone',
  txt_shxx: 'Merchant information',
  txt_shname: 'Merchant name  ',
  txt_ssmd: 'Store',
  txt_qx: 'Cancel',
  txt_mendian: 'Store',


  //数据总览模块
  txt_sTime: 'Select Time',
  txt_car_check: 'Inspection Rate',
  txt_findchance: "Sales\nLeads",
  txt_trackchace: 'Tracking Rate',
  txt_transform: 'Conversion Rate',
  txt_TotalData: 'Overall Date',
  txt_xxsj: 'Details',
  txt_zhsj: 'Converted',
  txt_TireWear: 'Tyre Wear',
  txt_DataHopper: 'Funnel',
  txt_jdcc: 'Car Traffics',
  txt_CheckCar: 'Scanned',
  txt_ChanceNum: 'Sales Leads',
  txt_TrackNum: 'Tracked',
  txt_TranseformNum: 'Conversion',
  txt_UnTrack: 'Not Tracked',
  txt_l: ' Units',
  txt_Time: 'Time',
  txt_Pwear1: 'Uneven',
  txt_car_plate: 'License',
  txt_Wear: 'Wear',
  txt_Pwear: 'Uneven',
  txt_NoData: 'No data',
  txt_GoodState: 'Normal',
  txt_Border: 'Boundary',
  txt_replace: 'Replace Immediately',
  txt_Total_Check: 'Scanned',
  txt_yel: 'Vehicle',
  txt_pmqk: 'Uneven Wear',
  txt_LightWear: 'Slight',
  txt_GraveWear: 'Serious',
  txt_hwtj: 'Rotation',
  txt_wxhw: 'No Need ',
  txt_xyhw: 'Need',
  txt_jcxq: 'Detail',
  txt_zhxq: 'Detail Conversion',
  txt_cc: 'car',
  txt_bfb: '%',
  txt_ltxs: 'Sales',
  txt_sldw: 'Alignment',
  txt_ddlph: 'Balance',
  txt_qt: 'Others',
  txt_zhqs: 'Conversion Trends',
  txt_ltxl: 'Tyre Sales',
  txt_ltfw: 'Tyre Service',
  txt_jt: 'Today',
  txt_zt: 'Yesterday',
  txt_bz: 'Week',
  txt_by: 'Month',
  txt_sy: 'Month',
  txt_jn: 'Year',
  txt_zhcl: 'Q’ty',
  txt_zhl: 'Rate(%)',
  txt_abjx: 'Vehicle distribution of “Boundary state”',
  txt_aljg: 'Vehicle distribution of “Replace immediately”',
  txt_qwpm: 'Vehicle distribution of “Slight uneven wear”',
  txt_ayzp: 'Vehicle distribution of “Serious uneven wear”',
  txt_lingt: '0 Tyre',
  txt_yt: '1 Tyre',
  txt_et: '2 Tyre',
  txt_st: '3 Tyre',
  txt_ft: '4 Tyre',



  //机会
  txt_xsjh: 'Sales Leads',
  txt_gzz: 'Tracking',
  txt_clwb: 'Complete',
  txt_ckbg: 'Reports',
  txt_yxs: 'All data displayed',
  txt_zhuiz: 'Track',
  txt_tix: 'Remind',
  txt_chuli: 'Handle',
  txt_yzh: 'Converted',
  txt_wzh: 'Not Converted',
  txt_gzsmts: 'Problems occurred during the inspection on {0}, and it is expected to come to the store for repair on {1}.',
  txt_czbty: 'Disagree',
  txt_yyx: 'Intent',
  txt_ltyg: '1 Tyre',
  txt_ltkg: '2 Tyre',
  txt_ltsang: '3 Tyre',
  txt_ltsig: '4 Tyre',
  txt_jhcl: 'Handle',
  txt_jhztai: 'Status',
  txt_crquy: 'Region',
  txt_chuliry: 'Processer',
  txt_chulijg: 'Result',
  txt_zhuanhuanr: 'Content',
  txt_zhuanhuaje: 'Income',
  txt_zhuanhuasj: 'Time',
  txt_zhuanhuayx: 'Schedule',
  txt_xuanzesj: 'Time',
  txt_ckxq: 'Details',
  txt_qsrsj: 'Fill in the schedule time',



  //设备
  txt_sbgl: 'Device',
  txt_tj: 'Add',
  txt_sbbh: 'Device Code',
  txt_gdssb: '{0} Device Total',
  txt_gjbb: 'Software Version',
  txt_tjsj: 'Starting Time',
  txt_zdgx: 'Automatic Update',
  txt_gxgj: 'Update',
  txt_jieb: 'Unbind',
  txt_sbtsxx: 'Firmware has a new version, click "Update Firmware" to update',
  txt_wjh: 'Unactivited',
  txt_lix: 'Off Line',
  txt_zaix: 'Online',
  txt_guz: 'Fault',
  txt_yijieb: 'Unbound',
  txt_yihuis: 'Recycled',
  txt_gxsbgj: 'Software Update',
  txt_gxsbgjts: 'Are you sure you want to update the device firmware?',
  txt_socketdk: 'The Communication with server is not established, please try again',
  txt_cscgts: ' Update request sent successfully',
  txt_jbsb: 'Unbind',
  txt_jbsbts: 'Are you sure to unbind the device ',
  txt_tscg: 'success',
  txt_zdgxgj: 'Auto Update',
  txt_gxgjts: 'Are you sure you want to {0} the automatic firmware update function',
  txt_beiz: 'NOTES',
  txt_qtxbz: 'Please write Remarks',
  txt_bdsbts: 'This App is only used to bind Tyre Scan HI 01 products, please confirm that device is correct.',
  txt_qdksb: 'Power on the Device',
  txt_dksbts1: '1.For new device, it will display guide after the device is power on.',
  txt_dksbts2: '2. If the device has been bound to other account, please click”unbind” to unbind the device in “setting” menu of the device.Then continuing binding process.',
  txt_yjdksblw: 'Device powered on and connected to network .',
  txt_xyb: 'Next',
  txt_qsclj: 'Please use the device to scan the QR code',
  txt_qscts1: 'After the scan is successful, ',
  txt_qscts2: 'a "beep" sound will be issued to indicate that the scan is successful.',
  txt_sbtssmcg: 'Prompt for successful code scanning',
  txt_ddsblw: 'Device Networking',
  txt_zznlbd: 'The device is binding,please waiting.',
  txt_qszdd: 'It may take a few seconds,please waiting.',
  txt_bdcg: 'Success',
  txt_tjcg: 'Success',
  txt_tjcgts: 'Congratulations, device added successfully. Please remark the device for easy identification',
  txt_fhsblb: 'Return to device list',
  txt_jxtjsb: 'Continue to add',
  txt_bzmc: 'Remarks',
  txt_bdsb: 'Binding',

  //检测记录
  txt_sx: 'Select',
  txt_khsj: 'Mobile Phone',
  txt_cphm: 'License',
  txt_cphm1: 'License',
  txt_clxh: 'Models',
  txt_xgbz: 'Comments',
  txt_gtfjl: '{0} Records',
  txt_jcsj: 'Date',
  txt_jcsj1: 'Detection Time',
  txt_xzkssj: 'Select Start Time',
  txt_xzjssj: 'Select End Time',
  txt_jcjg: 'Detection Result',
  txt_msqk: 'Tyre wear',
  txt_jygh: 'Immediate Replace',
  txt_zysh: 'Boundary',
  txt_zcsy: 'Normal',
  txt_zc: 'Normal',
  txt_cz: 'Reset',
  txt_qd: 'Sure',
  txt_jcjgd: 'Result',
  txt_msqkd: 'Tyre Wear',
  txt_sldwd: 'Alignment',
  txt_jyghd: 'Immediate Replace',
  txt_zysh: 'Boundary',
  txt_zcsyd: 'Normal',
  txt_xdwd: 'Immediate Replace',
  txt_xzyd: 'Boundary',
  txt_zcd: 'Normal',
  txt_bgxq: 'Detailed Report',
  txt_ljdy: 'Connection printing',
  txt_fwmd: 'Store',
  txt_mddz: 'Store Address',
  txt_jcsb: 'Device',
  txt_ddmd: 'Purpose',
  txt_lic: 'Odometer',
  txt_chex: 'Vehicle type',
  txt_jcjyi: 'Inspection Recommendations',
  txt_ysbs: 'Status',
  txt_ztms: 'Wears',
  txt_hwms: 'Uneven',
  txt_dqscjltx: 'Brake Distance Reminder',
  txt_bgxqts: ' The test was carried out by Tianjin auto testing center, an independent testing center.131.The test vehicle was Audi brand FV7203BECGB passenger car with a tyre model of 245/40R18 and a tyre inflation pressure of 230kpa for the front tyre and 220kpa for the rear tyre.The test site was Yancheng test site.The calculated speed range of the braking distance of the vehicle was deceleration from 100km/H to 0 km/H.',
  txt_wxsmgz: 'Please follow Tyhrhub official account by Wechat',
  txt_hwmsjh: 'Uniform Wear',
  txt_zqlun: 'L-F',
  txt_zhlun: 'L-R',
  txt_yqlun: 'R-F',
  txt_yhlun: 'R-R',
  txt_pingjunzhi: 'Brand',
  txt_guige: 'SPEC',
  txt_gongli: 'Kilometre',
  txt_ltwjc: 'Tyre not tested',
  txt_sewmts: 'Scan To Report',
  txt_ltws: 'Tyre Damage',
  txt_pinpai: 'Brand',
  txt_print: 'Print',


  //店员管理
  txt_xz: 'Add',
  txt_qy: 'Active',
  txt_qyz: 'Active',
  txt_ty: 'Disable',
  txt_yhzh: 'User Account',
  txt_lxfs: 'Mobile Phone',
  txt_cjsj: 'Creation Time',
  txt_bjxx: 'Edit',
  txt_xgmm: 'Modify password',
  txt_bgzt: 'Change Status',
  txt_qdytjm: 'Are you sure you want to {1} account number {0}?',
  txt_tjdy: 'Add',
  txt_bjdyxx: 'Edit Clerk Information',
  txt_zhxx: 'Information',
  txt_ygxm: 'Name',
  txt_qtxygxm: 'Please enter the employee  name',
  txt_lxdh: 'Mobile Phone',
  txt_qtxyglxdh: 'Please enter the employee Mobile Phone',
  txt_dxyzm: 'SMS verification code ',
  txt_qtxdxyzm: 'Please enter the verification code',
  txt_fsdx: 'Send SMS',
  txt_tjzh: 'Add',
  txt_baocun: 'Save',
  txt_gtgygzh: '{0} Accounts Total',

  txt_srczhdmm: 'Please enter the reset password',
  txt_kcfs: 'repeat after {0}',


  //登录
  txt_qdytcdlm: 'Are you sure to exit?',
  txt_qx: 'Cancel',
  txt_dl: 'Login',
  txt_qsrzh: 'Please enter account ID or Mobile Phone',
  txt_qsrmm: 'Please enter your password',
  txt_zcshzh: 'Account register',
  txt_shzhwjmm: 'Forget Password',
  txt_yzdqmm: 'Verify Current Password',
  txt_szxmm: 'Set New Password',
  txt_xgcg: 'Success',
  txt_qtxjmm: 'Please fill in the old password',
  txt_yzzcsj: 'Verify the Mobile Phone',
  txt_qtxxmm: 'Please fill in the new  password',
  txt_qzctxxmm: 'Please enter the password again',
  txt_lcmmsrbyz: 'Two password entries are inconsistent',
  txt_gxnxgcg: 'Congratulations, the registration was successful!',
  txt_qljndxmm: 'Please remember your new password',
  txt_fhgrzx: 'Go to the front page',

  txt_fsyzm: 'Send Messages',
  txt_qtxzcsjh: 'Please enter  Mobile Phone',
  txt_qtxtxyzm: 'Please enter the graphic verification code',
  txt_qsryzm: 'Please enter the verification code',
  txt_qszhhmm: 'Please set a password consisting of 6-18 digits and letters',
  txt_qzcsrmm: 'Please enter the password again',
  txt_lcmmbyz: 'Two password entries are inconsistent',
  txt_hdsy: 'Go to the front page',

  txt_zcshh: 'Account register',
  txt_fhdl: 'Return to login',
  txt_wlqqsb: 'The network request failed. Please try again',
  txt_wczc: 'Registration completed',
  txt_wsts: 'Please finish other informations before start using App.',
  txt_qtxshmc: 'Please enter Merchant name ',
  txt_shmc: 'Merchant name ',
  txt_rgszjd: 'Such as company phones number, fax, etc.',
  txt_qtlxfs: 'Other contact information',
  txt_kssy: 'Start using',
  txt_dphhh: 'Balance',
  txt_xiugai: 'Update',

  txt_zzjzsj: 'Loading Data',
  txt_bjshxx: 'Edit Merchant information',
  txt_chongxinhq: 'Re-send',
  txt_gaibangsj: 'Modify mobile phone',
  txt_yanzhengjsj: 'Verify old mobile phone',
  txt_bangdingxsj: 'Verify new mobile phone',
  txt_yhqsyxsjdl: 'Please login by new phone number',


  //门店
  txt_mendianId: 'Store ID',
  txt_mendianmc: 'Store Name',
  txt_mendiandz: 'Address',
  txt_mendiandh: 'Mobile Phone ',
  txt_caozuo: 'Process',
  txt_mendiangl: 'Stores',
  txt_gjmendian: '{0} Stores',
  txt_zhengchangyy: 'Open',
  txt_tingye: 'Closed',
  txt_gengdxx: 'More',
  txt_dianygl: 'Employees',
  txt_biangzt: 'Status Change',
  txt_qdygbzhuangtai: 'Ready to change the store status',
  txt_bjmendian: 'Edit',
  txt_xinzenmd: 'New Store',
  txt_qtxmdmc: 'Please enter the name',
  txt_qxzmddz: ' Please select the store address',
  txt_qtxxdz: 'Detailed Address',
  txt_xiangxidz: 'Detailed Address',
  txt_qtxmddh: 'Please fill in the store phone number',
  txt_dzxx: 'Manager Information',
  txt_chaungjianmendian: 'Create Store',
  txt_mendianxxxx: 'Details',
  txt_bianji: 'Edit',
  txt_mendianzt: 'Store Status',

  //商户数据总览
  txt_mendianshuju: 'Overview',
  txt_chakangdxxbb: 'More details',
  txt_jczcs: "Total inspection Q'ty",
  txt_mdpjjc: "Average Q'ty",
  txt_jdzcl: 'Total vehicle flow',
  txt_jcl: 'Inspection rate',
  txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
  txt_xyghltjgfb: '需更换轮胎的结果分布',
  txt_xzzyltjgfb: '需注意轮胎的结果分布',
  txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
  txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
  txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
  txt_jrzl: 'Overview',
  txt_xiangqbb: 'Details',
  txt_xuanzerqckxxsj: 'Please select period',
  txt_qxzsjd: 'Please select period',
  txt_sjdts: 'You can select only a period less than 30 days',
  txt_zonglan: 'Overview',
  txt_qushi: 'Trend',
  txt_shuliangtj: 'Amount',
  txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
  txt_mslttsfb: '磨损轮胎条数分布情况',
  txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
  txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
  txt_sldwfbqk: '四轮定位结论条数分布情况',
  txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
  txt_jccsqs: '检测次数趋势',
  txt_msqkslqs: '轮胎磨损情况数量趋势',
  txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
  txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
  txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
  txt_jccs: "Inspection Q'ty",
  txt_shuliang: "Q'ty",
  txt_zhanbi: '%',
  txt_chankangd: 'More',
  txt_chakanmdxxbb: 'Details',



  //登录新
  txt_xzshenfen: 'Please choose your role',
  txt_dlrolewz: '{0} Account',
  txt_qsrsjh: 'Please enter your Mobile Phone',
  txt_zhuce: 'Register',
  txt_wanjimima: 'Forgot Password',
  txt_wanshandzxx: 'Perfect the store manager number information',
  txt_qsrxm: ' Please enter your name',
  txt_qsrmdm: 'Please enter the store name',
  txt_qsrmdgddh: 'Please enter your phone',
  txt_qsrmddz: 'Please enter the store address',
  txt_qsrgsdz: ' Please enter the company address',
  txt_qsrxxdz: 'Please enter a detailed address',
  txt_tijiaocg: 'The registration was successful',
  txt_qsvbsylwmm: 'Please set a password of not less than 6 digits',
  txt_zhucerole: '{0}  Account Register',
  txt_qsrshh: 'Please enter merchant number',
  txt_qsrdzh: 'Please enter the manager number',
  txt_wsshhzl: ' Improve merchant number information',
  txt_wsdyhzl: ' Perfecting the Information of Shop Assistant Number',
  txt_qsrshm: ' Please enter the merchant name (company name)',
  txt_qsrshz: 'Please enter the merchant owner (responsible person)',
  txt_qsrzrqy: 'Please enter the responsibility area (work department)',
  txt_shanghudizhi: 'Merchant address',
  txt_yhycz: 'Account or Mobile Phone exists',
  txt_qsrzqdzh: ' Please enter the correct manager number',
  txt_qsrzqshh: ' Please enter the correct merchant number',
  txt_xzmdcx: 'Select Store',

  //国家
  txt_zhongguo: 'China',
  txt_mlxy: 'Malaysia',
  txt_yindu: 'India',
  txt_taiguo: 'Thailand',
  txt_oluosi: 'Russia',



  txt_taici: 'car',
  txt_jianyi: 'Suggest:',
  txt_jianyineirong: 'Tyre has abnormal wear,tyre rotation,please have a further check.',
  txt_jianyineirongzc: 'Normal',
  txt_bgtixing: 'Remind:',
  txt_bgtuxubfnr: 'According to the tyre wear, the braking distance is increased by {0}%(Estimated)',
  txt_scsltjcy: 'HH Tyre Tread Depth Detector',
  txt_xichemeirong: 'Car Wash & Detailing',
  txt_weixiubaoyang: 'Maintenance',
  txt_guenghuanluntai: 'Tyre replacement',
  txt_tireservice: 'Tyre service',
  txt_waishang: 'Trauma',
  txt_laohua: 'Aging ',
  txt_gubao: 'Bulge',
  txt_shijiantishi: 'End time must be greater than start time',

  txt_qxzclry: 'Processer cannot be empty',


  txt_lf_outworn: 'The outside of Left Front tyre is worn than inner.',
  txt_lf_innerworn: 'The inner of Left Front tyre is worn than outside.',
  txt_lf_bothsideworn: 'Both sides of Left Front tyre is worn than centre.',
  txt_lf_centreworn: 'Centre of Left Front tyre is worn than both sides.',
  txt_lb_outworn: 'The outside of Left Rear tyre is worn than inner.',
  txt_lb_innerworn: 'The inner of Left Rear tyre is worn than outside.',
  txt_lb_bothsideworn: 'Both sides of Left Rear tyre is worn than centre.',
  txt_lb_centreworn: 'Centre of Left Rear tyre is worn than both sides.',
  txt_rb_outworn: 'The outside of Right Rear is worn than inner.',
  txt_rb_innerworn: 'The inner of Right Rear is worn than outside.',
  txt_rb_bothsideworn: 'Both sides of Right Rear is worn than centre.',
  txt_rb_centreworn: 'Centre of Right Rear is worn than both sides.',
  txt_rf_outworn: 'The outside of Right Front tyre is worn than inner.',
  txt_rf_innerworn: 'The inner of Right Front tyre is worn than outside.',
  txt_rf_bothsideworn: 'Both sides of Right Front tyre is worn than centre.',
  txt_rf_centreworn: 'Centre of Right Front tyre is worn than both sides.',
  txt_tire_need_replace: 'Tyre wear status: Replace immediately',
  txt_tire_boundary: 'Tyre wear status: Boundary',
  'txt_tire_boundary;': 'Tyre wear status: Boundary',
  txt_alignment_chassis: 'Alignment and chassis check is recommended.',
  txt_wear_uniform: 'Tyre wear is uniform.',
  'txt_wear_uniform;': 'Tyre wear is uniform.',
  txt_do_further_check: 'Please do further check.',
  txt_uneven_check: 'Tyre has uneven wear, Please do further check.',
  'txt_uneven_check;': 'Tyre has uneven wear, Please do further check.',
  txt_tire_rotation: 'Suggest for tyre rotation.',
  txt_wear_normal: 'Tyre wear is normal.',
  'txt_wear_normal;': 'Tyre wear is normal.',
  txt_tire: 'Tire',
  txt_xiazai: 'Download',
  txt_xiazaishibai: 'downloads failed',


  //报告页新增
  'txt_tire_age_8': 'There are tyres have been used for more than 8 years, it is recommended to conduct a comprehensive inspection of tyres',
  'txt_tire_age_6': 'There are tyres that have been used for more than 6 years',
  'txt_tire_age_5': 'There are tyres have been used for more than 5 years, it is recommended to conduct a comprehensive inspection of tyres',
  'txt_tire_age_3': 'There are tyres that have been used for more than 3 years',
  'txt_tire_age_ok': 'Good tyre life',
  'txt_tire_age_ok;': 'Good tyre life',
  'txt_tire_trauma_check': 'There is a wound on the tyre surface, further examination is recommended',
  'txt_install_abnormal_check': 'Tyre installation is abnormal, further inspection is recommended',
  'txt_tire_appearance_ok': 'Tires in good condition',
  'trauma_lacerate': 'Balding',
  'trauma_dropblock': 'Drop block',
  'trauma_puncture': 'Puncture',
  'trauma_scratch': 'Scratch',
  'txt_tire_age': 'Service life of tyres',
  'txt_tire_appearance': 'The tyre appearance',
  //未翻译
  txt_plcl: 'Batch',
  txt_qbxz: 'All',
  txt_scjcjg: 'Last',
  txt_ltxhlcgs: 'Tyre range estimation',
  txt_ltazhuang: 'Installation:',
  txt_wear_overall: 'Wears',
  txt_pattern_wear: 'Uneven',
  txt_ltlcgstm: 'According to the current tyre wear situation, the tyre mileage is {0} km (estimated value)',
  txt_yichang: 'Abnormal',
  txt_qjybjcltazqk: 'Please further check the tyre installation',
  txt_dottx: 'Dot usage time reminder',
  txt_dottxjy: 'Tires have been used for more than 3 years, please check them regularly',
  txt_danweinian: '(Unit:Year)',
  txt_danweikm: '(Unit:km)',
  txt_shurujb: "Enter 'Unbind' to disarm the device",
  txt_shuruzqwa: 'Please enter text as prompted',
  txt_myhqdsj: 'No DOT time obtained',
  txt_dotjstx: 'The remaining service life of the tyre is about {0} days',
  txt_dotjstx2: 'The service life of tyres has exceeded 5 years, please replace them immediately',
  txt_dotsjztx: '(DOT time:Tyre manufacturing date)',
  txt_gelie: 'Balding',
  txt_diaokuai: 'Drop block',
  txt_chaungci: 'Puncture',
  txt_cashang: 'Scratch',
  txt_yichang: 'Abnormal',
  'txt_tire_need_replace;': 'Tyre wear status: Replace immediately',

  //未翻译
  txt_jishimz: 'Technician',
  txt_ltlcgsnew: 'Tyre range is {0} km',
  txt_ltlcgsnewin: 'Tyre range is {0} miles',
  txt_msjxtx:'The tyre has reached the limit, please replace it immediately',
  txt_ltfz:'reverse internal and external installation',
  txt_pinnate_check: 'There is pinnate wear on the tyre, please check further',
  txt_pinnate_wear: 'Pinnate wear',
 
  txt_install_check: 'Installation inspection',
  txt_install_ok:'Normal installation',
  LF:'[L-F]',
  RF:'[R-F]',
  LB:'[L-R]',
  RB:'[R-R]',
  FF:'[F-F]',
  BB:'[B-B]',
  txt_appearance_check:'Tyre appearance is abnormal, further inspection is recommended',
  txt_uneven_center:'Abnormal wear in the middle of the tyre. It is recommended to check the tyre pressure',
  txt_uneven_out:'The outer side of the tyre is worn abnormally. It is recommended to check the four-wheel alignment and tyre pressure',
  txt_pinnate_check:'There is feather wear on the tyre. It is recommended to further check the chassis parts',
  txt_uneven_inside :'The inner side of the tyre is worn abnormally. It is recommended to check the four-wheel alignment and tyre pressure',
  txt_uneven_bothside:'Abnormal wear on both sides of the tyre. It is recommended to check the four-wheel alignment and tyre pressure.',
  
  txt_msyzljgh:'The tyre is seriously worn. Please replace it immediately。',
  txt_serious_trauma_check:"The tyre has serious injury. It is recommended to replace the tyre",
  txt_appearance_lookup:"Please check the appearance of the tyres",
  txt_wear_lookup :"Please check tyre wear",
  txt_dotscsj:'Production time: {0} ({1} year {2} week)',
  txt_whqdscsj:'Production time not obtained',
  purp_tireservice:'Tyre service',
  purp_vehicle_inspection:'CAR MECHANICS CHECK', 
  txt_chassis_check :'Chassis check',
  txt_chassis_ok:'The chassis is well checked',
  txt_chassis_oil:'The shock absorber leaks oil, further confirmation is recommended, if necessary, please replace it.',
  txt_chassis_aging :'Axle head rubber aging, replacement treatment is recommended.',


 txt_null:'',
 // new add  wu
 txt_lights:'LIGHTS',
 txt_high_beam:'HIGH BEAN',
 txt_low_beam:'LOW BEAM',
 txt_daytime:'DAYTIME',
 txt_fog_light:'FOG LIGHT',
 txt_brake_light:'BRAKE LIGHT',
 txt_turn_signals:'TURN SIGNALS',
 txt_backup_lights:'BACKUP LIGHTS',
 txt_hazards:'HAZARDS',

 txt_glass:'GLASS',
 txt_windshield:'WINDSHIELD',
 txt_back_glass:'BACK GLASS',
 txt_right_side_windows:'RIGHT SIDE WINDOWS',
 txt_left_side_windows:'LEFT SIDE WINDOWS ',
 txt_wipers_front:'WIPERS FRONT',
 txt_wipers_rear:'WIPERS REAR',

 txt_under_hood:'UNDER HOOD',
 txt_horn:'HORN',
 txt_oil_level:'OIL LEVEL',
 txt_air_filter:'AIR FILTER',
 txt_trans_fluid:'MOTOR OIL',
 txt_coolant_level:'COOLANT LEVEL',
 txt_power_steering_fluid:'POWER STEERING FLUID',
 txt_windshield_washer_fluid:'GLASS WASHING  LIQUID',
 txt_belts:'BELTS',
 txt_hoses:'HOSES',
 txt_ac_system:'AC SYSTEM',
 txt_battery:'BATTERY',

 txt_under_vehicle:'UNDERBODY',
 txt_suspension:'SUSPENSION',
 txt_exhaust:'EXHAUST',
 txt_brake_lines:'BRAKE LINES',
 txt_oil_drain_plug:'OIL DRAIN PLUG',
 txt_differential:'DIFFERENTIAL',

 txt_brakes:'BRAKES',
 txt_front_left:'FRONT LEFT',
 txt_front_right:'FRONT RIGHT',
 txt_rear_left:'REAR LEFT',
 txt_rear_right:'REAR RIGHT',
 txt_parking_brake:'PARKING BRAKE',
 txt_spare_pressure:'SPARE PRESSURE',
   
 txt_interior:'INTERIOR',
 txt_cabin_fiter:'CABIN FITER',
 txt_heating:'HEATING',
 txt_AC_system:'AC SYSYEM',
 txt_interior_lights:'INTERIOR LIGHTS',
 txt_front_defrost:'FRONT DEFROST',
 txt_rear_defrost:'REAR DEFROST',

 txt_tire_pressure:'Tyre PRESSURE',
 txt_left_front:'LEFT FRONT',
 txt_right_front:'RIGHT FRONT',
 txt_left_rear:'LEFT REAR',
 txt_right_rear:'RIGHT REAR',

 //add dill
 txt_cphm_dill:'License Plate',
 txt_jcsj_dill:'Delection Time',
 txt_chex_dill:'Vehicle Model',
 txt_vechicle_make:'Vehicle Make',
 txt_vechicle_year:'Vehicle Year',
 txt_dill_title:'Inspection Report',
 txt_dill_title_h:'(All measurements in 32nds)',
 txt_wear:'Wear',
 txt_wearlow1:'Normal',
 txt_wearmiddle1:'Boundary',
 txt_wearhigh1:'Replace immediately',
 txt_dill_ltws:'Damage Photos',
 txt_download_report:'Download Report',


  //cormach
  txt_hood:'ENGINE BONNET',
  txt_wash_liquid:'GLASS WASHING LIQUID',
  txt_level_control:'LEVEL CONTROL',
  txt_haoxiaoxi:'OK',
  txt_vedi_Note:'Caution',
  txt_replace1:'Needs Attention',
  txt_radiator_fluid:'RADIATOR FLUID',
  txt_engine_oil:'MOTOR OIL',
  txt_brake_fluid:'BRAKE FLUID',
  txt_quality_control:'QUALITY CHECK',
  txt_multimeter:'MULTIMETER TEST',
  txt_subtotal:'UNDERBODY',
  txt_shock_absorber:'SHOCK ABSORBERS',
  txt_check_loss:'CHECK OF VISIBLE LEAKS',
  txt_brake_disc:'BRAKE DISCS',
  txt_wear_condition:'WEARING',
  txt_brake_pads:'BRAKE PADS',
  txt_change_control:'CHANGE CONTROL',
  txt_air_control:'AIR CONDITIONER',
  txt_last_reload:'LAST RECHARGE',
  txt_lighting:'LIGHTS',
  txt_verification1:'WIPERS',
  txt_dynamometer:'WHEEL NUTS TENSIONED BY',
  txt_batteria:'BATTERY',
  txt_verification:'OPERATION CHECK',
  txt_levellow:'ok',
  txt_levelmiddle:'Read note',
  txt_levelhigh:'Replace',
  txt_tyrenumber:'Tread Depth:',
  txt_cormach_title:'Wear&Uneven',
  txt_wearlow:'normal',
  txt_wearmiddle:'slight wear',
  txt_wearhigh:'severe wear',
  txt_namtishi:'Tread Depth in 32nds',
  txt_zhiliangkongzhi:'Quality control',
  txt_buchongzhengduan:'Notes',  
  txt_season_summer:'Summer tyre',
  txt_season_winter:'Winter tyre',
  txt_wheelalignment: 'Need to do dynamic balance and wheel alignment',

  //米其林新加
  txt_trauma_eattyre:'Fetation',
  txt_uneven_eattyre:'It is recommended to carry out dynamic balancing, and check the four-wheel alignment and suspension system',
  txt_appearance_eattyre:'It is recommended to carry out dynamic balancing, and check the four-wheel alignment and suspension system',
  txt_chassis_eattyre:'It is recommended to check the four-wheel alignment and suspension system',
  txt_uneven_high_eattyre:'It is suggested to replace the tyre and check the four-wheel alignment and suspension system',
  txt_appearance_high_eattyre:'It is suggested to carry out dynamic balancing and check the four-wheel alignment and suspension system',
  txt_chassis_high_eattyre:'It is suggested to check the four-wheel alignment and suspension system',
  txt_chassis_uneven:'It is recommended to check the four-wheel alignment and suspension system for abnormal tyre wear',
  txt_pianmoyichang:'Abnormal tyre Excessive wear',
  txt_qiao: 'Axis',
  txt_left: 'Left',
  txt_right: 'Right',
  txt_lun: 'Tire',
  txt_huawen: 'Pattern',
  txt_taihao: 'Number',
  txt_taiya: 'Tyre Pressure',
  txt_chexlw: 'Models',
  txt_jiancerenyuan: 'Technician',
  txt_beitai:'Spare Tyre',
  txt_tuoche:'Tractor',
  txt_guache:'Trailer',




  txt_khxm:'Customer Name',
  txt_khyx:'Customer Mail',


}


// WEBPACK FOOTER //
// ./src/i18n/en.js